export default __webpack_public_path__ + "static/expMob-61bd8c56b7e3496017f416c8f65c0549.mp4";